export const FAST_CHARGING_LEADERBOARD_CONTENT_PATH = 'research/infographics/fast-charging-leaderboard';
